import classNames from 'classnames'
import React from 'react'
import styles from './accountProfileStrength.module.scss'
import { ReactComponent as CompletedIcon } from 'images/icons/icn_completed_tick.svg'
import { ReactComponent as IncompleteIcon } from 'images/icons/icn_arrow_right_dark.svg'

type ConditionalProps =
  | { external: true; onClick?: never; href?: string }
  | { external?: false; onClick?: () => void; href?: string }

interface Props {
  copy: string
  isCompleted?: boolean
  isClickable?: boolean
}

export type SideNavItemProps = Props & ConditionalProps

const ProfileStrengthListItem = ({ copy, onClick, external, href, isCompleted, isClickable = true }: SideNavItemProps) => {

  const { Element, elementProps }: any = !isCompleted && href ? { Element: 'a', elementProps: { href } } : { Element: 'p', elementProps: {} }

  return (
    <li
      onClick={isCompleted ? undefined : onClick}
      className={classNames(
        (isCompleted ? styles.profileStrengthCompletedState : styles.profileStrengthIncompleteState),
        (isClickable && !isCompleted ? styles.clickable : null)
      )}
    >
      <Element {...elementProps}>
        <span className={styles.text}>{copy}</span>
        <span className={styles.icon}>{isCompleted ? <CompletedIcon /> : <IncompleteIcon />}</span>

      </Element>

    </li>

  )
}

export default ProfileStrengthListItem
